class ProductBundleComponent extends HTMLElement {
  constructor() {
    super();
    this.selectedVariants = {};
    this.selectedLengths = {}; // Track selected length for each group
    this.bundleTitle = this.getAttribute('bundle-title') || 'Bundle';
    this.parentProductPrice = parseInt(this.getAttribute('parent-product-price')) || 0;
    this.parentProductCompareAtPrice = parseInt(this.getAttribute('parent-product-compare-at-price')) || 0;
    this.showSelectionMessage = this.getAttribute('show-selection-message') === 'true';
    this.selectionMessageText = this.getAttribute('selection-message-text') || '';
    this.imageMetafieldBundle = this.getAttribute('image-metafield-bundle') || '';
    this.bundleName = this.getAttribute('bundle-name') || '';
    this.bundleHandle = this.getAttribute('bundle-handle') || '';
    this.useSelectInputs = this.getAttribute('use-select-inputs') === 'true'; // New variable for select vs buttons
  }

  connectedCallback() {
    const data = JSON.parse(this.querySelector('#bundle-products-data').textContent);
    this.products = data;

    const colorDataEl = document.querySelector('#bundle-color-data');
    if (colorDataEl) {
      this.colorData = JSON.parse(colorDataEl.textContent);
    } else {
      this.colorData = {};
    }

    this.groupedProducts = this.groupProductsByName();

    // Initialize default lengths for groups with short variants
    Object.entries(this.groupedProducts).forEach(([groupName, products]) => {
      const hasShort = products.some(p => p.title.includes(' - Short'));
      if (hasShort) {
        this.selectedLengths[groupName] = 'regular';
      }
    });

    this.render();
    this.attachEventListeners();

    // Set initial label values for selects
    if (this.useSelectInputs) {
      this.updateInitialLabels();
    }
  }

  groupProductsByName() {
    const groups = {};

    this.products.forEach(product => {
      const baseName = product.title.split(' - ')[0].trim();
      if (!groups[baseName]) {
        groups[baseName] = [];
      }
      groups[baseName].push(product);
    });

    return groups;
  }

  render() {
    this.innerHTML = `
            <div class="bundle-product-container">
                <div class="bundle-product-header">
                    <h2 class="bundle-product-title">${this.bundleTitle}</h2>
            
                </div>
                ${Object.entries(this.groupedProducts).map(([groupName, products]) => this.renderProductGroup(groupName, products)).join('')}
                <div class="bundle-product-bottom-container">
                ${this.showSelectionMessage ? `
                    <div class="bundle-product-selection-message" style="display: none;">
                        ${this.selectionMessageText}
                    </div>
                ` : ''}
                <button class="bundle-product-add-button" disabled>
                    ADD TO BAG - 
                    ${this.parentProductCompareAtPrice && this.parentProductCompareAtPrice > this.parentProductPrice ? 
                        `<span class="bundle-product-compare-price">$${Math.ceil(this.parentProductCompareAtPrice / 100)}</span> ` : ''}
                    ${this.parentProductPrice ? `$${Math.ceil(this.parentProductPrice / 100)}` : ''}
                </button>
                </div>
            </div>
        `;
  }

  renderProductGroup(groupName, products) {
    // Check if this group has both regular and short versions
    const hasRegular = products.some(p => !p.title.includes(' - Short'));
    const hasShort = products.some(p => p.title.includes(' - Short'));
    const hasLengthVariants = hasShort; // Only show length if there are Short variants

    // Get current product based on selected length
    const selectedLength = this.selectedLengths[groupName] || 'regular';
    let currentProduct;
    if (hasLengthVariants) {
      currentProduct = products.find(p =>
        selectedLength == 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
      ) || products[0];
    } else {
      currentProduct = products[0];
    }

    // Get colors based on current length selection
    const lengthFilteredProducts = hasLengthVariants ?
      products.filter(p => selectedLength === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')) :
      products;

    // Get unique colors and sizes from length-filtered products
    const colors = this.getUniqueColors(lengthFilteredProducts);
    const sizes = this.getUniqueSizes(lengthFilteredProducts);
    const lengths = this.getUniqueLengths(products); // lengths from all products

    return `
            <div class="bundle-product-group" data-group="${groupName}">
                <div class="bundle-product-image">
                    <img src="${currentProduct.featured_image}" alt="${groupName}">
                    <p class="bundle-product-name only-mobile">${groupName}</p>
                </div>
                <div class="bundle-product-details">
                    <h3 class="bundle-product-name">${groupName}</h3>
                    

            
                    <div class="bundle-product-section">
                        <label class="bundle-product-label">${theme.strings.optionColor.toUpperCase()}<span class="selected-color"></span></label>
                        <div class="bundle-product-colors">
                            ${colors.map(color => {
      let bgStyle = '';
      // Check if any product in the length-filtered group has a color code for this color
      let colorCode = null;
      lengthFilteredProducts.forEach(product => {
        if (product.metafields && product.metafields.color_code) {
          // Check if the metafield color matches the color or is part of a compound color (e.g., "Oat Milk" matches "Oat Milk/Lightning")
          const metaColor = product.metafields.color_name?.trim();
          const targetColor = color?.trim();
          if (metaColor === targetColor || (targetColor && targetColor.includes('/') && targetColor.startsWith(metaColor + '/'))) {
            colorCode = product.metafields.color_code;
          }
        }
      });

      if (colorCode) {
        bgStyle = `background: ${colorCode}; --swatch-color: ${colorCode};`;
      } else {
        // Fallback to global color data or default
        const hexColor = this.getColorHex(color);
        bgStyle = `background: ${hexColor}; --swatch-color: ${hexColor};`;
      }
      return `
                                    <div class="bundle-product-color-swatch" 
                                         data-color="${color}" 
                                         style="${bgStyle}"
                                         title="${color}">
                                    </div>
                                `;
    }).join('')}
                        </div>
                    </div>

                    <div class="bundle-options-container-bottom">
                        ${sizes.length > 0 ? `
                            <div class="bundle-product-section">
                                ${this.useSelectInputs ? `
                                    <label class="bundle-product-bottom-label" for="bundle-size-select-${groupName.replace(/\s+/g, '-').toLowerCase()}">${theme.strings.optionSize}</label>
                                    <select id="bundle-size-select-${groupName.replace(/\s+/g, '-').toLowerCase()}" class="bundle-product-size-select bundle-product-select" data-group="${groupName}">
                                        ${sizes.map(size => `
                                            <option value="${size}">${size}</option>
                                        `).join('')}
                                    </select>
                                ` : `
                                    <label class="bundle-product-label">${theme.strings.optionSize.toUpperCase()}<span class="selected-size"></span></label>
                                    <div class="bundle-product-sizes">
                                        ${sizes.map(size => `
                                            <button class="bundle-product-size-option" 
                                                    data-size="${size}"
                                                    data-group="${groupName}">
                                                ${size}
                                            </button>
                                        `).join('')}
                                    </div>
                                `}
                            </div>
                        ` : ''}

                        ${hasLengthVariants ? `
                            <div class="bundle-product-section bundle-product-section-length">
                                ${this.useSelectInputs ? `
                                    <div class="bundle-product-length-select-container">
                                        <label class="bundle-product-label" for="bundle-length-select-${groupName.replace(/\s+/g, '-').toLowerCase()}">${theme.strings.optionLength}</label>
                                        <select id="bundle-length-select-${groupName.replace(/\s+/g, '-').toLowerCase()}" class="bundle-product-length-select bundle-product-select" data-group="${groupName}">
                                            <option value="" disabled ${!selectedLength ? 'selected' : ''}>${theme.strings.optionLength.toUpperCase()}</option>
                                            <option value="regular" ${selectedLength === 'regular' ? 'selected' : ''}>${theme.strings.lengthRegular}</option>
                                            <option value="short" ${selectedLength === 'short' ? 'selected' : ''}>${theme.strings.lengthShort}</option>
                                        </select>
                                    </div>
                                ` : `
                                    <label class="bundle-product-label">${theme.strings.optionLength.toUpperCase()}<span class="selected-length"></span></label>
                                    <div class="bundle-product-lengths">
                                        <button class="bundle-product-length-option ${selectedLength === 'regular' ? 'selected' : ''}" 
                                                data-length="regular"
                                                data-group="${groupName}">
                                            Regular
                                        </button>
                                        <button class="bundle-product-length-option ${selectedLength === 'short' ? 'selected' : ''}" 
                                                data-length="short"
                                                data-group="${groupName}">
                                            Short
                                        </button>
                                    </div>
                                `}
                            </div>
                        ` : ''}
                    </div>
                </div>
            </div>
                    `;
  }

  getUniqueColors(products) {
    const colors = new Set();
    const colorOptions = new Set();

    // Collect all colors from all products in the group
    products.forEach(product => {
      // First check if product has metafield color
      if (product.metafields && product.metafields.color_name) {
        // Trim any whitespace from color names
        colors.add(product.metafields.color_name.trim());
      }

      // Also check options
      product.options.forEach(option => {
        if (option.key === 'color') {
          option.values.forEach(value => colorOptions.add(value.trim()));
        }
      });
    });

    // Combine metafield colors with option colors
    colorOptions.forEach(color => colors.add(color));

    // If no colors found yet, check variants
    if (colors.size === 0) {
      products.forEach(product => {
        product.variants.forEach(variant => {
          // Assume color is in option1 if not in sizes
          if (variant.option1 && !['XXS', 'XS', 'S', 'M', 'L', 'XL', '1X', '2X', '3X'].includes(variant.option1)) {
            colors.add(variant.option1.trim());
          }
        });
      });
    }

    return Array.from(colors);
  }

  getUniqueSizes(products) {
    const sizes = new Set();
    const sizeOptions = new Set();

    products.forEach(product => {
      product.options.forEach(option => {
        if (option.key === 'size') {
          option.values.forEach(value => sizeOptions.add(value));
        }
      });
    });
    
    // Helper function to get size order value
    const getSizeOrderValue = (size) => {
      const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '1X', '2X', '3X'];
      
      // Check for combined sizes like "XS/S" or "M/L"
      if (size.includes('/')) {
        const parts = size.split('/');
        // Use the first part for ordering
        const firstSize = parts[0].trim();
        const index = sizeOrder.indexOf(firstSize);
        return index === -1 ? 999 : index;
      }
      
      // Regular single size
      const index = sizeOrder.indexOf(size);
      return index === -1 ? 999 : index;
    };
    
    if (sizeOptions.size > 0) {
      return Array.from(sizeOptions).sort((a, b) => {
        const orderA = getSizeOrderValue(a);
        const orderB = getSizeOrderValue(b);
        
        if (orderA === orderB) {
          // If same base size, sort alphabetically
          return a.localeCompare(b);
        }
        return orderA - orderB;
      });
    }
    
    products.forEach(product => {
      product.variants.forEach(variant => {
        [variant.option1, variant.option2, variant.option3].forEach(opt => {
          if (opt && (opt.match(/^(XXS|XS|S|M|L|XL|XXL|1X|2X|3X)(\/.+)?$/))) {
            sizes.add(opt);
          }
        });
      });
    });

    return Array.from(sizes).sort((a, b) => {
      const orderA = getSizeOrderValue(a);
      const orderB = getSizeOrderValue(b);
      
      if (orderA === orderB) {
        // If same base size, sort alphabetically
        return a.localeCompare(b);
      }
      return orderA - orderB;
    });
  }

  getUniqueLengths(products) {
    const lengths = new Set();
    const lengthOptions = new Set();

    products.forEach(product => {
      product.options.forEach(option => {
        if (option.key === 'length') {
          option.values.forEach(value => lengthOptions.add(value));
        }
      });
    });
    if (lengthOptions.size > 0) {
      return Array.from(lengthOptions).sort();
    }
    products.forEach(product => {
      product.variants.forEach(variant => {
        if (variant.option3) lengths.add(variant.option3);
      });
    });

    return Array.from(lengths).sort();
  }

  getColorHex(colorName) {
    // First check if any product has a color code for this color in metafields
    if (this.products) {
      for (const product of this.products) {
        if (product.metafields &&
          product.metafields.color_code) {
          // Check if the metafield color matches the color or is part of a compound color
          const metaColor = product.metafields.color_name?.trim();
          const targetColor = colorName?.trim();
          if (metaColor === targetColor || (targetColor && targetColor.includes('/') && targetColor.startsWith(metaColor + '/'))) {
            return product.metafields.color_code;
          }
        }
      }
    }

    const colorHandle = colorName.toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

    if (this.colorData && this.colorData[colorHandle]) {
      return this.colorData[colorHandle].hex;
    }
    const colorMap = {
      'Black': '#000000',
      'White': '#FFFFFF',
      'Navy': '#000080',
      'Red': '#FF0000',
      'Blue': '#0000FF',
      'Green': '#008000',
      'Pink': '#FFC0CB',
      'Gray': '#808080',
      'Grey': '#808080',
      'Brown': '#A52A2A'
    };

    return colorMap[colorName] || '#CCCCCC';
  }

  updateInitialLabels() {
    // Set initial values for length labels
    Object.entries(this.groupedProducts).forEach(([groupName, products]) => {
      const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
      if (!groupEl) return;

      // Update length label if exists
      const lengthLabel = groupEl.querySelector('.selected-length');
      if (lengthLabel && this.selectedLengths[groupName]) {
        lengthLabel.textContent = this.selectedLengths[groupName] === 'short' ? theme.strings.lengthShort : theme.strings.lengthRegular;
      }
    });
  }

  attachEventListeners() {
    this.querySelectorAll('.bundle-product-color-swatch').forEach(colorEl => {
      colorEl.addEventListener('click', (e) => this.handleColorSelection(e));
    });
    this.querySelectorAll('.bundle-product-size-option').forEach(sizeEl => {
      sizeEl.addEventListener('click', (e) => this.handleSizeSelection(e));
    });
    this.querySelectorAll('.bundle-product-length-option').forEach(lengthEl => {
      lengthEl.addEventListener('click', (e) => this.handleLengthSelection(e));
    });

    // Add event listeners for select elements
    this.querySelectorAll('.bundle-product-size-select').forEach(select => {
      select.addEventListener('change', (e) => this.handleSizeSelectChange(e));
    });
    this.querySelectorAll('.bundle-product-length-select').forEach(select => {
      select.addEventListener('change', (e) => this.handleLengthSelectChange(e));
    });

    // No need for length select listeners anymore, using length buttons now
  }

  handleColorSelection(e) {
    const colorEl = e.currentTarget;
    const color = colorEl.dataset.color;
    const group = colorEl.closest('.bundle-product-group').dataset.group;

    colorEl.closest('.bundle-product-colors').querySelectorAll('.bundle-product-color-swatch').forEach(el => {
      el.classList.remove('selected');
    });
    colorEl.classList.add('selected');
    const colorLabel = colorEl.closest('.bundle-product-section').querySelector('.selected-color');
    if (colorLabel) colorLabel.textContent = color;

    // Update product image based on color selection
    this.updateProductImageForColor(group, color);

    this.updateAvailableOptions(group);
    this.updateSelectedVariant(group);
    this.updateAddButton();
  }

  handleSizeSelection(e) {
    const sizeEl = e.currentTarget;
    const group = sizeEl.dataset.group;
    const size = sizeEl.dataset.size;

    if (sizeEl.disabled) return;

    sizeEl.closest('.bundle-product-sizes').querySelectorAll('.bundle-product-size-option').forEach(el => {
      el.classList.remove('selected');
    });
    sizeEl.classList.add('selected');
    const sizeLabel = sizeEl.closest('.bundle-product-section').querySelector('.selected-size');
    if (sizeLabel) {
      sizeLabel.textContent = size;
    }
    this.updateAvailableOptions(group);
    this.updateSelectedVariant(group);
    this.updateAddButton();
  }

  handleSizeSelectChange(e) {
    const select = e.currentTarget;
    const group = select.dataset.group;
    const size = select.value;

    const sizeLabel = select.closest('.bundle-product-section').querySelector('.selected-size');
    if (sizeLabel) {
      sizeLabel.textContent = size || '';
    }

    // Always update variant and button, even if size is empty
    this.updateSelectedVariant(group);
    this.updateAddButton();
  }


  handleLengthSelection(e) {
    const lengthEl = e.currentTarget;
    const group = lengthEl.dataset.group;
    const length = lengthEl.dataset.length;

    if (lengthEl.disabled) return;

    // Update selected state
    lengthEl.closest('.bundle-product-lengths').querySelectorAll('.bundle-product-length-option').forEach(el => {
      el.classList.remove('selected');
    });
    lengthEl.classList.add('selected');

    // Store selected length
    this.selectedLengths[group] = length;

    const lengthLabel = lengthEl.closest('.bundle-product-section').querySelector('.selected-length');
    if (lengthLabel) lengthLabel.textContent = length === 'short' ? theme.strings.lengthShort : theme.strings.lengthRegular;

    // Update image based on selected length
    const products = this.groupedProducts[group];
    const newProduct = products.find(p =>
      length === 'short' ? p.title.includes(' - short') : !p.title.includes(' - short')
    ) || products[0];

    const groupEl = this.querySelector(`.bundle-product-group[data-group="${group}"]`);
    const imgEl = groupEl.querySelector('.bundle-product-image img');
    if (imgEl && newProduct) {
      imgEl.src = newProduct.featured_image;
    }

    // Update available options but keep current selections if possible
    this.updateAvailableOptions(group);
    this.updateSelectedVariant(group);
    this.updateAddButton();
  }

  handleLengthSelectChange(e) {
    const select = e.currentTarget;
    const group = select.dataset.group;
    const length = select.value;

    // Store selected length
    this.selectedLengths[group] = length;

    const lengthLabel = select.closest('.bundle-product-section').querySelector('.selected-length');
    if (lengthLabel) lengthLabel.textContent = length === 'short' ? theme.strings.lengthShort : theme.strings.lengthRegular;

    // Get current selected color
    const groupEl = this.querySelector(`.bundle-product-group[data-group="${group}"]`);
    const selectedColor = groupEl.querySelector('.bundle-product-color-swatch.selected')?.dataset.color;

    // Update image based on selected length AND color
    const products = this.groupedProducts[group];
    const lengthFilteredProducts = products.filter(p =>
      length === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
    );

    // Find product with the selected color
    let newProduct = null;
    if (selectedColor) {
      for (const product of lengthFilteredProducts) {
        const hasColor = product.variants.some(v =>
          v.option1?.trim() === selectedColor?.trim() ||
          v.option2?.trim() === selectedColor?.trim() ||
          v.option3?.trim() === selectedColor?.trim()
        );
        if (hasColor) {
          newProduct = product;
          break;
        }
      }
    }

    // Fallback to first product of the selected length
    if (!newProduct) {
      newProduct = lengthFilteredProducts[0] || products[0];
    }

    const imgEl = groupEl.querySelector('.bundle-product-image img');
    if (imgEl && newProduct) {
      imgEl.src = newProduct.featured_image;
    }

    // Update colors based on new length selection
    this.updateColorsForLength(group);

    // Update available options but keep current selections if possible
    this.updateAvailableOptions(group);
    this.updateSelectedVariant(group);
    this.updateAddButton();
  }

  updateColorsForLength(groupName) {
    const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
    const products = this.groupedProducts[groupName];
    const selectedLength = this.selectedLengths[groupName] || 'regular';

    // Get the currently selected color before updating
    const selectedColorEl = groupEl.querySelector('.bundle-product-color-swatch.selected');
    const selectedColor = selectedColorEl?.dataset.color;

    // Filter products by length
    const lengthFilteredProducts = products.filter(p =>
      selectedLength === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
    );

    // Get colors only from length-filtered products
    const colors = this.getUniqueColors(lengthFilteredProducts);

    // Update the color swatches
    const colorsContainer = groupEl.querySelector('.bundle-product-colors');
    if (colorsContainer) {
      colorsContainer.innerHTML = colors.map(color => {
        let bgStyle = '';
        // Check if any product in the filtered group has a color code for this color
        let colorCode = null;
        lengthFilteredProducts.forEach(product => {
          if (product.metafields && product.metafields.color_code) {
            // Check if the metafield color matches the color or is part of a compound color
            const metaColor = product.metafields.color_name?.trim();
            const targetColor = color?.trim();
            if (metaColor === targetColor || (targetColor && targetColor.includes('/') && targetColor.startsWith(metaColor + '/'))) {
              colorCode = product.metafields.color_code;
            }
          }
        });

        if (colorCode) {
          bgStyle = `background: ${colorCode}; --swatch-color: ${colorCode};`;
        } else {
          // Fallback to global color data or default
          const hexColor = this.getColorHex(color);
          bgStyle = `background: ${hexColor}; --swatch-color: ${hexColor};`;
        }

        // Check if this color should be selected
        const isSelected = selectedColor && color?.trim() === selectedColor?.trim();

        return `
                    <div class="bundle-product-color-swatch ${isSelected ? 'selected' : ''}" 
                         data-color="${color}" 
                         style="${bgStyle}"
                         title="${color}">
                    </div>
                `;
      }).join('');

      // Re-attach event listeners
      colorsContainer.querySelectorAll('.bundle-product-color-swatch').forEach(colorEl => {
        colorEl.addEventListener('click', (e) => this.handleColorSelection(e));
      });

      // Update color label if a color is still selected
      if (selectedColor) {
        const colorLabel = groupEl.querySelector('.selected-color');
        if (colorLabel) {
          // Check if the selected color is still available
          const colorStillAvailable = colors.some(c => c?.trim() === selectedColor?.trim());
          if (colorStillAvailable) {
            colorLabel.textContent = selectedColor;
            // Update the product image for the selected color in the new length
            this.updateProductImageForColor(groupName, selectedColor);
          } else {
            // Color not available in new length, clear selection
            colorLabel.textContent = '';
            // Clear size selection as well since it depends on color
            const sizeLabel = groupEl.querySelector('.selected-size');
            if (sizeLabel) sizeLabel.textContent = '';
            const sizeSelect = groupEl.querySelector('.bundle-product-size-select');
            if (sizeSelect) sizeSelect.value = '';
          }
        }
      }
    }
  }

  updateAvailableOptions(groupName) {
    const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
    const selectedColor = groupEl.querySelector('.bundle-product-color-swatch.selected')?.dataset.color;
    const selectedSize = groupEl.querySelector('.bundle-product-size-option.selected')?.dataset.size;

    if (!selectedColor) return;

    const products = this.groupedProducts[groupName];
    const selectedLength = this.selectedLengths[groupName] || 'regular';

    // First filter by length, then find product with selected color
    const lengthFilteredProducts = products.filter(p =>
      selectedLength === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
    );

    // Find a product that has the selected color
    let currentProduct = null;
    for (const product of lengthFilteredProducts) {
      // Check if this product has the selected color
      const hasColor = product.variants.some(variant => {
        // Check all option positions for color (trim whitespace for comparison)
        const hasColorMatch = variant.option1?.trim() === selectedColor?.trim() ||
          variant.option2?.trim() === selectedColor?.trim() ||
          variant.option3?.trim() === selectedColor?.trim();
        return hasColorMatch;
      });

      if (hasColor) {
        currentProduct = product;
        break;
      }
    }

    // Fallback to first product if no match
    if (!currentProduct) {
      currentProduct = lengthFilteredProducts[0] || products[0];
    }

    const availableVariants = [];
    let colorPosition = null;
    let sizePosition = null;

    // Find positions in the current product
    currentProduct.options.forEach((option, index) => {
      if (option.key === 'color') colorPosition = index + 1;
      if (option.key === 'size') sizePosition = index + 1;
    });

    // Check variants from the current product only
    currentProduct.variants.forEach(variant => {
      const variantColor = colorPosition === 1 ? variant.option1 : (colorPosition === 2 ? variant.option2 : variant.option3);
      const variantSize = sizePosition === 1 ? variant.option1 : (sizePosition === 2 ? variant.option2 : variant.option3);

      if (variantColor?.trim() === selectedColor?.trim() && variant.available) {
        availableVariants.push(variant);
      }
    });
    if (sizePosition) {
      // Update button states
      groupEl.querySelectorAll('.bundle-product-size-option').forEach(sizeEl => {
        const size = sizeEl.dataset.size;
        const isAvailable = availableVariants.some(v => {
          const variantSize = sizePosition === 1 ? v.option1 : (sizePosition === 2 ? v.option2 : v.option3);
          return variantSize === size;
        });
        sizeEl.disabled = !isAvailable;
      });

      // Update select options if using selects
      const sizeSelect = groupEl.querySelector('.bundle-product-size-select');
      if (sizeSelect) {
        const currentValue = sizeSelect.value;
        sizeSelect.innerHTML = '<option value="">' + theme.strings.optionSize.toUpperCase() + '</option>';

        const availableSizes = new Set();
        availableVariants.forEach(v => {
          const variantSize = sizePosition === 1 ? v.option1 : (sizePosition === 2 ? v.option2 : v.option3);
          if (variantSize) availableSizes.add(variantSize);
        });

        // Helper function to get size order value
        const getSizeOrderValue = (size) => {
          const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '1X', '2X', '3X'];
          
          // Check for combined sizes like "XS/S" or "M/L"
          if (size.includes('/')) {
            const parts = size.split('/');
            // Use the first part for ordering
            const firstSize = parts[0].trim();
            const index = sizeOrder.indexOf(firstSize);
            return index === -1 ? 999 : index;
          }
          
          // Regular single size
          const index = sizeOrder.indexOf(size);
          return index === -1 ? 999 : index;
        };
        
        // Add available sizes in order
        Array.from(availableSizes).sort((a, b) => {
          const orderA = getSizeOrderValue(a);
          const orderB = getSizeOrderValue(b);
          
          if (orderA === orderB) {
            // If same base size, sort alphabetically
            return a.localeCompare(b);
          }
          return orderA - orderB;
        }).forEach(size => {
          const option = document.createElement('option');
          option.value = size;
          option.textContent = size;
          if (size === currentValue) option.selected = true;
          sizeSelect.appendChild(option);
        });
      }
    }

  }

  updateSelectedVariant(groupName) {
    const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
    const selectedColor = groupEl.querySelector('.bundle-product-color-swatch.selected')?.dataset.color;

    let selectedSize;
    if (this.useSelectInputs) {
      selectedSize = groupEl.querySelector('.bundle-product-size-select')?.value;
    } else {
      selectedSize = groupEl.querySelector('.bundle-product-size-option.selected')?.dataset.size;
    }

    const selectedLengthEl = groupEl.querySelector('.bundle-product-length-option.selected');

    if (!selectedColor) {
      return;
    }

    // For selects, we need both color AND size to find a variant
    if (this.useSelectInputs && !selectedSize) {
      return;
    }

    const products = this.groupedProducts[groupName];
    const selectedLength = this.selectedLengths[groupName] || 'regular';

    // First filter by length, then find product with selected color (same logic as updateAvailableOptions)
    const lengthFilteredProducts = products.filter(p =>
      selectedLength === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
    );

    // Find a product that has the selected color
    let currentProduct = null;
    for (const product of lengthFilteredProducts) {
      const hasColor = product.variants.some(variant =>
        variant.option1?.trim() === selectedColor?.trim() ||
        variant.option2?.trim() === selectedColor?.trim() ||
        variant.option3?.trim() === selectedColor?.trim()
      );

      if (hasColor) {
        currentProduct = product;
        break;
      }
    }

    // Fallback to first product if no match
    if (!currentProduct) {
      currentProduct = lengthFilteredProducts[0] || products[0];
    }

    let matchingVariant = null;
    let colorPosition = null;
    let sizePosition = null;
    let lengthPosition = null;

    currentProduct.options.forEach((option, index) => {
      if (option.key === 'color') colorPosition = index + 1;
      if (option.key === 'size') sizePosition = index + 1;
      if (option.key === 'length') lengthPosition = index + 1;
    });

    currentProduct.variants.forEach(variant => {
      const variantColor = colorPosition === 1 ? variant.option1 : (colorPosition === 2 ? variant.option2 : variant.option3);
      const variantSize = sizePosition ? (sizePosition === 1 ? variant.option1 : (sizePosition === 2 ? variant.option2 : variant.option3)) : null;
      const variantLength = lengthPosition ? (lengthPosition === 1 ? variant.option1 : (lengthPosition === 2 ? variant.option2 : variant.option3)) : null;

      const colorMatch = variantColor?.trim() === selectedColor?.trim();
      const sizeMatch = !sizePosition || !selectedSize || variantSize === selectedSize;
      const lengthMatch = !lengthPosition || !selectedLengthEl || variantLength === selectedLengthEl?.dataset.length;

      if (colorMatch && sizeMatch && lengthMatch && variant.available) {
        matchingVariant = variant;
      }
    });

    if (matchingVariant) {
      this.selectedVariants[groupName] = {
        product: currentProduct,
        variant: matchingVariant
      };

      if (matchingVariant.image) {
        const imgEl = groupEl.querySelector('.bundle-product-image img');
        if (imgEl) {
          imgEl.src = matchingVariant.image;
        }
      }
    } else {
      // Remove any previously selected variant if no match
      delete this.selectedVariants[groupName];
    }
  }

  updateProductImageForColor(groupName, selectedColor) {
    const products = this.groupedProducts[groupName];
    const selectedLength = this.selectedLengths[groupName] || 'regular';

    // Filter by length first
    const lengthFilteredProducts = products.filter(p =>
      selectedLength === 'short' ? p.title.includes(' - Short') : !p.title.includes(' - Short')
    );

    // Find product with the selected color
    let productWithColor = null;
    for (const product of lengthFilteredProducts) {
      const hasColor = product.variants.some(variant =>
        variant.option1?.trim() === selectedColor?.trim() ||
        variant.option2?.trim() === selectedColor?.trim() ||
        variant.option3?.trim() === selectedColor?.trim()
      );

      if (hasColor) {
        productWithColor = product;
        break;
      }
    }

    if (productWithColor) {
      const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
      const imgEl = groupEl.querySelector('.bundle-product-image img');
      if (imgEl) {
        // Try to find variant with this color to get its image
        const variantWithColor = productWithColor.variants.find(v =>
          (v.option1?.trim() === selectedColor?.trim() || v.option2?.trim() === selectedColor?.trim() || v.option3?.trim() === selectedColor?.trim()) && v.image
        );

        if (variantWithColor && variantWithColor.image) {
          imgEl.src = variantWithColor.image;
        } else {
          imgEl.src = productWithColor.featured_image;
        }
      }
    }
  }

  // This method is no longer needed since we're not dynamically switching products

  updateAddButton() {
    const button = this.querySelector('.bundle-product-add-button');
    const message = this.querySelector('.bundle-product-selection-message');

    const allGroupsSelected = Object.keys(this.groupedProducts).every(group => {
      const hasVariant = !!this.selectedVariants[group];
      const isFullySelected = this.isVariantFullySelected(group);
      return hasVariant && isFullySelected;
    });

    if (allGroupsSelected) {
      const compareAtPriceHtml = this.parentProductCompareAtPrice && this.parentProductCompareAtPrice > this.parentProductPrice ? 
        `<span class="bundle-product-compare-price">$${Math.ceil(this.parentProductCompareAtPrice / 100)}</span> ` : '';
      const priceText = `$${Math.ceil(this.parentProductPrice / 100)}`;
      button.innerHTML = `ADD TO BAG - ${compareAtPriceHtml}${priceText}`;
      button.disabled = false;
      button.onclick = () => this.addToCart();
      if (message && this.showSelectionMessage) {
        message.style.display = 'none';
      }
    } else {
      const compareAtPriceHtml = this.parentProductCompareAtPrice && this.parentProductCompareAtPrice > this.parentProductPrice ? 
        `<span class="bundle-product-compare-price">$${Math.ceil(this.parentProductCompareAtPrice / 100)}</span> ` : '';
      const priceText = `$${Math.ceil(this.parentProductPrice / 100)}`;
      button.innerHTML = `ADD TO BAG - ${compareAtPriceHtml}${priceText}`;
      button.disabled = true;
      if (message && this.showSelectionMessage) {
        message.style.display = 'block';
      }
    }
  }

  isVariantFullySelected(groupName) {
    const groupEl = this.querySelector(`.bundle-product-group[data-group="${groupName}"]`);
    const hasColor = groupEl.querySelector('.bundle-product-color-swatch.selected');

    let hasSize = true;
    if (this.useSelectInputs) {
      const sizeSelect = groupEl.querySelector('.bundle-product-size-select');
      hasSize = !sizeSelect || sizeSelect.value !== '';
    } else {
      const needsSize = groupEl.querySelector('.bundle-product-size-option');
      hasSize = !needsSize || groupEl.querySelector('.bundle-product-size-option.selected');
    }

    // Check if length is needed
    const products = this.groupedProducts[groupName];
    const hasShortVariants = products.some(p => p.title.includes(' - Short'));
    let hasLength = true;

    if (hasShortVariants) {
      if (this.useSelectInputs) {
        const lengthSelect = groupEl.querySelector('.bundle-product-length-select');
        hasLength = !lengthSelect || lengthSelect.value !== '';
      } else {
        hasLength = groupEl.querySelector('.bundle-product-length-option.selected') !== null;
      }
    }

    return hasColor && hasSize && hasLength;
  }

  async addToCart() {
    const timestamp = Date.now();
    const items = Object.values(this.selectedVariants).map(item => ({
      id: item.variant.id,
      quantity: 1,
      properties: {
        '_vpv_bundle': timestamp,
        '_vpv_bundle_title': this.bundleName,
        '_vpv_bundle_image': this.imageMetafieldBundle,
        '_vpv_bundle_handle': this.bundleHandle
      }
    }));

    const button = this.querySelector('.bundle-product-add-button');
    const originalHTML = button.innerHTML;

    try {
      button.disabled = true;
      button.textContent = theme.strings.addingToCart;

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();

      if (response.ok && !data.status) {
        button.textContent = theme.strings.addedToCart;


        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2000);
      } else {
        // Handle Shopify API errors (e.g., out of stock, invalid variant)
        const errorMessage = data.description || data.message || 'Failed to add to cart';
        throw new Error(errorMessage);
      }
    } catch (error) {
      button.textContent = theme.strings.addToCartError;
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.disabled = false;
      }, 2000);
    }
  }
}

customElements.define('product-bundle-component', ProductBundleComponent);
